<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main [title]="'Banner (warning)'">
      <div class="content" content>
        <div>
          <p>Title, long text, link (click event)</p>
          <app-banner title="Warning" (clickEvent)="test()" linkLabel="Link">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </app-banner>
        </div>
        <div>
          <p>Short text, link</p>
          <app-banner linkLabel="Link">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text.</p>
          <app-banner>Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text. (Size: thin)</p>
          <app-banner size="thin">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>No icon</p>
          <app-banner [icon]="false">Lorem ipsum dolor sit amet.</app-banner>
        </div>
      </div>
    </vi-panel>

    <vi-panel main [title]="'Banner (info)'">
      <div class="content" content>
        <div>
          <p>Title, long text, link (routerLink)</p>
          <app-banner
            type="info"
            title="Info"
            [linkForRouter]="['/home']"
            [queryParams]="{ gatewaySerial: '1' }"
            linkLabel="Link"
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </app-banner>
        </div>
        <div>
          <p>Short text, link</p>
          <app-banner type="info" linkLabel="Link">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text.</p>
          <app-banner type="info">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text. (Size: thin)</p>
          <app-banner type="info" size="thin">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>No icon</p>
          <app-banner type="info" [icon]="false">Lorem ipsum dolor sit amet.</app-banner>
        </div>
      </div>
    </vi-panel>

    <vi-panel main [title]="'Banner (error)'">
      <div class="content" content>
        <div>
          <p>Title, long text, link (href)</p>
          <app-banner type="error" title="Error" link="/home" linkLabel="Link">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </app-banner>
        </div>
        <div>
          <p>Short text, link</p>
          <app-banner type="error" linkLabel="Link">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text.</p>
          <app-banner type="error">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text. (Size: thin)</p>
          <app-banner type="error" size="thin">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>No icon</p>
          <app-banner type="error" [icon]="false">Lorem ipsum dolor sit amet.</app-banner>
        </div>
      </div>
    </vi-panel>

    <vi-panel main [title]="'Banner (success)'">
      <div class="content" content>
        <div>
          <p>Title, long text, link</p>
          <app-banner type="success" title="Success" linkLabel="Link">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </app-banner>
        </div>
        <div>
          <p>Short text, link</p>
          <app-banner type="success" linkLabel="Link">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text.</p>
          <app-banner type="success">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>Short text. (Size: thin)</p>
          <app-banner type="success" size="thin">Lorem ipsum dolor sit amet.</app-banner>
        </div>
        <div>
          <p>No icon</p>
          <app-banner type="success" [icon]="false">Lorem ipsum dolor sit amet.</app-banner>
        </div>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
